import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

/**
 * True while a client-side navigation is in flight.
 *
 * The directory and blog filters navigate with next/link, so the browser no longer shows its
 * own loading indicator — without this the page looks frozen for the duration of
 * getServerSideProps after a filter or page click.
 */
const useRouteChangePending = (): boolean => {
  const router = useRouter();
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    const handleStart = () => setIsPending(true);
    const handleDone = () => setIsPending(false);

    router.events.on('routeChangeStart', handleStart);
    router.events.on('routeChangeComplete', handleDone);
    router.events.on('routeChangeError', handleDone);

    return () => {
      router.events.off('routeChangeStart', handleStart);
      router.events.off('routeChangeComplete', handleDone);
      router.events.off('routeChangeError', handleDone);
    };
  }, [router.events]);

  return isPending;
};

export default useRouteChangePending;
